import { Exclude, Type } from 'class-transformer';

export class PageDTO<T> {
  number: number;

  numberOfElements: number;

  totalPages: number;

  totalElements: number;

  @Type(options => (options.newObject as PageDTO<T>).genericType)
  content: T[] = [];

  @Exclude()
  private readonly genericType: any;

  constructor(genericType: any = null) {
    this.genericType = genericType;
  }
}
